export default {
	title: "Колесо Удачи",
	Lucky: "Удача",
	wheels: "Колёса",
	winningrecord: "История выигрышей",
	ActivityRules: "Правила акции",
	ActivityRulesContent: "Для получения дополнительной информации о розыгрыше свяжитесь с нашей службой поддержки.",
	award: {
		title: "Поздравляем с выигрышем!",
		btn: "Получить приз"
	},
	noticeItem: "{0} получил {1}",
	lotteryDraws: "{0} розыгрышей лотереи",
	noAvailableTimes: "Недостаточно доступных попыток. Пожалуйста, свяжитесь с поддержкой.",
	noOpen: "Еще не открыто",
	noWinning: "Продолжайте стараться",
	ViewALlPrizes: "Посмотреть все призы",
	myPrizes: "Мои призы",
	share: "Поделиться с другом"
};
